<canvas #chart></canvas>
<div class="legend-container" #legendContainer>
    <div class="center-container" *ngIf="CenterTemplate" (click)="CenterClick.emit()">
        <div class="center-content" *ngIf="CenterTemplate">
            <ng-container *ngTemplateOutlet="CenterTemplate"></ng-container>
        </div>
    </div>
</div>
